import React from "react";

import { useNavigate } from "react-router-dom";
import { StartConversation } from "../Casinoengine/StartConversation";
import business from "../../images/casinoengine/Bussiness-Models.webp";
import Integration from "../../images/casinoengine/CE-Integration.webp";

import Card from "./Card";

const CasinoBusinessModal = () => {
  const navigate = useNavigate();
  const cardData = [
    {
      title: "CasinoEngine Turnkey Solution",
      strongText: "for operators in need of full platform services",
      description:
        "Ideal for operators seeking a complete platform setup, this solution is powered by our iGaming management platform, GamMatrix, and CasinoEngine. Enjoy seamless cross-product bonusing across brands and verticals.",
      imgSrc:
        "https://everymatrix.com/wp-content/uploads/2021/12/gonzo_presenting_globe.png",
      imgAlt: "CasinoEngine Turnkey",
    },
    {
      title: "CasinoEngine Integration",
      strongText:
        "for operators with own iGaming management platform in need of a robust casino solution with seamless and flexible bonusing",
      description:
        "Perfect for operators with their own iGaming platform who want a premium casino content solution. Benefit from industry-leading content selection and seamless cross-product bonusing.",
      imgSrc: Integration,
      imgAlt: "CasinoEngine",
    },
    {
      title: "SlotMatrix Aggregation",
      strongText:
        "for operators looking to get quick access to an unrivalled portfolio of content, including strong, exclusive brands",
      description:
        "Gain fast access to the world’s largest collection of top-tier gaming content, including market-specific games. Leverage tournaments, challenges, and powerful promotional tools across all content.",
      imgSrc:
        "https://everymatrix.com/wp-content/uploads/2021/12/CE-Content-Feed-img1-1-1.png",
      imgAlt: "SlotMatrix",
    },
  ];
  return (
    <>
      <main className="overflow-hidden">
        <section class="simple-intro">
          <div class="container container_custom">
            <div class="row align-items-center justify-content-between">
              <div class="col-xl-5 col-lg-6">
                <h1 class="section-title heading_left">Business Models</h1>
                <div class="description">
                  <p>
                    CasinoEngine goes beyond simple vendor integration. We offer
                    a range of tailored business setups—from popular,
                    proprietary, and exclusive gaming content to fully managed
                    turnkey casino solutions—designed to meet the unique needs
                    of our clients.
                  </p>
                </div>
                <div class="btns pt-5">
                  <a href="/connect" class="btn btn_blue">
                    Contact us
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <img
                  src={business}
                  class="illustration"
                />
              </div>
            </div>
          </div>
          <a href="#explore" class="explore"></a>
        </section>
        <div>
          {cardData.map((item, index) => {
            const bgColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff"; // Even = gray, Odd = white
            const reverse = index % 2 !== 0; // Odd index = reverse layout
            return (
              <Card
                key={index}
                title={item.title}
                strongText={item.strongText}
                description={item.description}
                imgSrc={item.imgSrc}
                imgAlt={item.imgAlt}
                backgroundColor={bgColor}
                reverse={reverse}
              />
            );
          })}
        </div>

        <StartConversation />
      </main>
    </>
  );
};

export default CasinoBusinessModal;
